<template>
  <div id="fragebogen" v-show="questions.length">
    <div v-for="( quest, idx ) in questions" :key="'question_' + idx"
         class="content-block content-block--question ">
      <div class="box">
        <h2>{{quest.title}}</h2>

        <template v-if="quest.type == 'group'">
          <question v-for="(subQuestion, sidx) in quest.questions" :key="'subquestion' + sidx"
                    :question="subQuestion" v-on:change="collectValue"></question>
        </template>
        <template v-else>
          <question :question="quest" v-on:change="collectValue"></question>
        </template>
      </div>
    </div>

    <div class="content-block content-block--submit">
      <div class="block block--seamless">
        <button type="submit" @click="submitData">Bewertung abschliessen</button>
      </div>
    </div>
  </div>
</template>

<script>
	// import RateBox from '../components/subparts/RateBox/RateBox';
	// import QuestionsBox from '../components/subparts/QuestionsBox';
	import { BAROMETER_SUBMIT } from '../../utils/store/actions/general';
	import api, { ApiDefaults } from '../../utils/api_call';
	import QuestionsBox from './QuestionsBox';
	import RateBox from './RateBox/RateBox';

	export default {
		name: "Fragebogen",
		data() {
			return {
				resultData: {}
			};
		},
		props: {
			questions: {
				type: Array,
				required: true
			},
			url: {
				type: String,
				required: true
			}
		},
		methods: {
			collectValue: function ( evt ) {
				if ( evt.hasOwnProperty('name') ) {
					this.resultData[ evt.name ] = evt.value;
				}
			},

			submitData: function () {

				let postData = new URLSearchParams();

				for ( var key in this.resultData ) {
					if ( !this.resultData.hasOwnProperty(key) ) continue;

					postData.append('fragebogen[' + key + ']', this.resultData[ key ]);
				}

				this.sending = true;
				let apiParams = Object.assign(
					{},
					ApiDefaults,
					{
						url: (ApiDefaults.url + this.url.substring(9)),
						method: 'post',
						data: postData,
						params: null
					}
				);

				api(apiParams)
					.then(( response ) => {
						this.sending = false;
						let d = new Date(),
							  tstamp = Math.floor(d.getTime() / 1000);
						if ( typeof this.$store === 'object' ) {
							this.$store.commit(BAROMETER_SUBMIT, tstamp);
						}
					})
					.catch(( response ) => {
						setTimeout(function () {

							this.sending = false;
							if ( typeof this.$store === 'object' ) {
								this.$store.commit(BAROMETER_SUBMIT, false);
							}

						}, 1500);
					});
			}
		},
		mounted() {

			for ( let q = 0; q < this.questions.length; q++ ) {
				let question = this.questions[ q ];
				if ( question.type !== 'group' ) {
					// if( question.type === 'rate' ) {
					// 	let  base = (question.answers.to - question.answers.from) / 2;
					// 	this.resultData[ question.name ] = base;
					// }
					// else {
					this.resultData[ question.name ] = '';
				}
			}
		},
		components: {
			'rate-box': RateBox,
			'question': QuestionsBox
		}
	};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/subparts/Fragebogen.vue